
import chargerActionTypes from '../types/chargerActionTypes';
import connectorActionTypes from '../types/connectorActionTypes';

const initialState = {
    chargers: {
        chargersArray: [],
        publicChargersArray: [],
        driverChargersArray: []
    },
    favoriteChargersIds: [],
    selectedCharger: null,
    myActiveChargersIds: [],
    chargingSummery: null,
    currentTransaction: null,
    stateInfo: {
        isLoading: false,
        isSuccess: false,
        isError: false,
        error: null,
        isInitialFetch: false
    }

};

const chargerReducer = (state = initialState, action) => {
    switch (action.type) {
        case chargerActionTypes.START_ADD_CHARGER:
        case chargerActionTypes.START_DELETE_CHARGER:
        case chargerActionTypes.START_UPDATE_CHARGER:
        case chargerActionTypes.START_GET_CHARGERS:
        case connectorActionTypes.START_STOP_TRANSACTION:
        case connectorActionTypes.START_START_TRANSACTION:
        case connectorActionTypes.START_START_SMART_TRANSACTION:
            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: true,
                    isSuccess: false,
                    isError: false,
                    error: null
                }
            };
        case chargerActionTypes.ADD_CHARGER_SUCCESS:
        case chargerActionTypes.UPDATE_CHARGER_SUCCESS:
        case chargerActionTypes.DELETE_CHARGER_SUCCESS:
        case chargerActionTypes.REMOVE_FAVORITE_CHARGER_SUCCESS:
        case chargerActionTypes.ADD_FAVORITE_CHARGER_SUCCESS:
        case chargerActionTypes.STOP_TRANSACTION_SUCCESS:
            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: false,
                    isSuccess: true,
                    isError: false
                }
            };
        case chargerActionTypes.ADD_CHARGER_FAILURE:
        case chargerActionTypes.UPDATE_CHARGER_FAILURE:
        case chargerActionTypes.DELETE_CHARGER_FAILURE:
        case chargerActionTypes.ADD_FAVORITE_CHARGER_FAILURE:
        case chargerActionTypes.REMOVE_FAVORITE_CHARGER_FAILURE:
        case connectorActionTypes.START_TRANSACTION_FAILURE:
        case connectorActionTypes.STOP_TRANSACTION_FAILURE:
        case connectorActionTypes.START_SMART_TRANSACTION_FAILURE:
            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: false,
                    isSuccess: false,
                    isError: true,
                    error: action.payload,
                }
            };


        case chargerActionTypes.GET_ALL_CHARGERS_SUCCESS:
            // Check if all the arrays in the chargers object are empty
            const hasNoChargersYet = Object.values(state.chargers).every(array => array.length === 0);
            return {
                ...state,
                chargers: action.payload,
                stateInfo: {
                    ...state.stateInfo,
                    // Update isInitialFetch based on whether any chargers exist
                    isInitialFetch: hasNoChargersYet
                }
            };
        case chargerActionTypes.GET_CHARGER_SUCCESS:
            return {
                ...state,
                chargers: {
                    ...state.chargers,
                    chargersArray: action.payload
                },
                stateInfo: {
                    ...state.stateInfo,
                    // Update isInitialFetch based on whether any chargers exist
                    isInitialFetch: false
                }
            };
        case chargerActionTypes.GET_DRIVER_CHARGER_SUCCESS:
            return {
                ...state,
                chargers: {
                    ...state.chargers,
                    driverChargersArray: action.payload
                }
            };
        case chargerActionTypes.GET_PUBLIC_CHARGER_SUCCESS:
            return {
                ...state,
                chargers: {
                    ...state.chargers,
                    publicChargersArray: action.payload
                },
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: false
                }
            };
        case chargerActionTypes.GET_FAVORITE_SUCCESS:
            return {
                ...state,
                favoriteChargersIds: action.payload,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: false
                }
            };
        case chargerActionTypes.SELECT_CHARGER:
            return {
                ...state,
                selectedCharger: action.payload
            };
        case chargerActionTypes.SET_MY_ACTIVE_CHARGER_ID:
            return {
                ...state,
                myActiveChargersIds: action.payload
            };
        case chargerActionTypes.UNSELECT_CHARGER:
            return {
                ...state,
                selectedCharger: initialState.selectedCharger
            };
        case chargerActionTypes.RESET:
            return {
                ...initialState
            };

        //signalR
        case chargerActionTypes.UPDATE_TRANSACTION_DATA:
            return {
                ...state,
                chargers: {
                    ...state.chargers,
                    chargersArray: updateTransactionData(state.chargers.chargersArray, action.payload),
                    driverChargersArray: updateTransactionData(state.chargers.driverChargersArray, action.payload),
                    publicChargersArray: updateTransactionData(state.chargers.publicChargersArray, action.payload),
                }
            };
        case chargerActionTypes.UPDATE_CHARGER_STATUS:
            return {
                ...state,
                chargers: {
                    ...state.chargers,
                    chargersArray: updateChargerStatus(state.chargers.chargersArray, action.payload, 'id'),
                    driverChargersArray: updateChargerStatus(state.chargers.driverChargersArray, action.payload, 'id'),
                    publicChargersArray: updateChargerStatus(state.chargers.publicChargersArray, action.payload, 'id'),
                }
            };
        case chargerActionTypes.CLEAR_TRANSACTION_DATA:
            return {
                ...state,
                chargers: {
                    ...state.chargers,
                    chargersArray: state.chargers.chargersArray.map(({ transaction: _, ...rest }) => rest),
                    driverChargersArray: state.chargers.driverChargersArray.map(({ transaction: _, ...rest }) => rest),
                    publicChargersArray: state.chargers.publicChargersArray.map(({ transaction: _, ...rest }) => rest),
                }
            };
        case chargerActionTypes.UPDATE_CONNECTOR_STATUS:
            return {
                ...state,
                chargers: {
                    ...state.chargers,
                    chargersArray: updateConnectorStatus(state.chargers.chargersArray, action.payload, 'id'),
                    driverChargersArray: updateConnectorStatus(state.chargers.driverChargersArray, action.payload, 'id'),
                    publicChargersArray: updateConnectorStatus(state.chargers.publicChargersArray, action.payload, 'id'),
                },
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: isLoadingWhenConnectorStatus(state.chargers.chargersArray, action.payload)
                }
            };
        case chargerActionTypes.UPDATE_CHARGING_SUMMERY:
            return {
                ...state,
                chargingSummery: action.payload,
            };

        case chargerActionTypes.RESET_STATE_INFO:
            return {
                ...state,
                stateInfo: initialState.stateInfo
            };
        case connectorActionTypes.GET_TRANSACTION_SUMMERY_SUCCESS:
            return {
                ...state,
                chargers: {
                    ...state.chargers,
                    chargersArray: getTransactionDataSummery(state.chargers.chargersArray, action.payload),
                    driverChargersArray: getTransactionDataSummery(state.chargers.driverChargersArray, action.payload),
                    publicChargersArray: getTransactionDataSummery(state.chargers.publicChargersArray, action.payload),
                }
            };
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};


const updateChargerStatus = (arr, payload, field) => {
    return arr.map((item) => {
        if (item[field] === payload[field]) {
            return {
                ...item,
                status: payload.status,
            };
        } else {
            return item;
        }
    });
}
//OLD
const updateTransactionData = (arr, payload) => {
    return arr.map((item) => {
        if (item.chargerId === payload.chargePointId) {
            return {
                ...item,
                connectors: item.connectors.map((connector, index) => {
                    if (connector.connectorNumber === payload.connectorId) {
                        const newTransactionDataSummary = {
                            chargingStrategyTotalDataList: payload.transactionDataSummary?.chargingStrategyTotalDataList ? payload.transactionDataSummary?.chargingStrategyTotalDataList : connector.transaction?.transactionDataSummary?.chargingStrategyTotalDataList,
                            // Preserve existing chargingDataList or create a new array with current payload data
                            chargingDataList: connector.transaction?.transactionDataSummary?.chargingDataList
                                ? [...connector.transaction.transactionDataSummary.chargingDataList, payload.data]
                                : connector.transaction?.transactionDataSummary?.chargingDataList,
                        };
                        return {
                            ...connector,
                            transaction: {
                                ...connector?.transaction,
                                energy: payload.data.energy,
                                total_amp: payload.data.total_amp,
                                price: payload.price,
                                soc: payload.data.soc,
                                startChargeTime: payload?.startChargeTime,
                                transactionDataSummary: newTransactionDataSummary,
                                power: payload.data.power,
                                voltage: payload.data.voltage,
                                maxVoltage: payload.data.MaxVoltage ?? payload.data.maxVoltage
                            }
                        };
                    }
                    return connector
                }),
            };
        } else {
            return item;
        }
    });
}

const getTransactionDataSummery = (arr, payload) => {
    return arr.map((item) => {
        if (item.chargerId === payload.chargerId) {
            return {
                ...item,
                connectors: item.connectors.map((connector, index) => {
                    if (connector.connectorNumber === payload.connectorId) {
                        return {
                            ...connector,
                            // chargingStrategyTotalDataList: payload.chargingStrategyTotalDataList,
                            transaction: {
                                ...connector.transaction,
                                transactionDataSummary: {
                                    ...connector.transaction?.transactionDataSummary,
                                    chargingStrategyTotalDataList: payload.transactionDataSummery.chargingStrategyTotalDataList,
                                    chargingDataList: [
                                        ...payload.transactionDataSummery.chargingDataList
                                    ],
                                }


                            }
                        };
                    }
                    return connector
                }),
            };
        } else {
            return item;
        }
    });
}

const updateConnectorStatus = (arr, payload, field) => {
    return arr.map((item) => {
        if (item.id === payload.chargePointNO) {
            return {
                ...item,
                connectors: item.connectors.map((connector) => {
                    if (connector[field] === payload[field]) {
                        return {
                            ...connector,
                            status: payload.status,
                            // Only overwrite transaction when the payload explicitly carries a value.
                            // An absent field (undefined) means the server didn't send transaction
                            // data this tick — preserve whatever the connector already has.
                            transaction: payload.transaction !== undefined
                                ? payload.transaction
                                : connector.transaction,
                        };
                    }
                    return connector;
                }),
            };
        }
        return item;
    });
};

const isLoadingWhenConnectorStatus = (arr, payload) => {
    const item = arr?.find((item) => item.id === payload.chargePointNO);
    return item ? (item.isAutoCharging && payload.status === 'Preparing') : false;
}



export default chargerReducer;

